const mEditionBillingMyShoppingModalPendingPayMethodsChange = {
  mEditionBillingMyShoppingModalPendingPayMethodsChange: {
    subscription: {
      discount: {
        line1: 'Se aplicó descuento',
        line2: 'del'
      },
      idExternal: 'ID de suscripción en',
      method: 'Medio de pago',
      plan: 'A pagar en',
      paymentNext: ' El próximo pago será el',
      statePaymentChange: {
        to: 'desde',
        state: 'Pendiente',
        title: 'Cambio  Medio de Pago'
      }
    },
    title: 'Intento de cambio de Medio de Pago',
    warningParagraph: 'Si el intento aún permanece pendiente ten en cuenta que la activación puede demorar hasta 24 horas.'
  }
}
export default mEditionBillingMyShoppingModalPendingPayMethodsChange
